<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <logo width="400"></logo>
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-6">
                  <h4 class="mb-4">Login - Intranet C&A</h4>
                  <p>Bienvenido, inicie sesión para ingresar a nuestra aplicación.</p>
                </div>

                <div>
                  <vs-input
                    v-validate="'required|email'"
                    data-vv-validate-on="blur"
                    name="email"
                    type="email"
                    label-placeholder="Email"
                    placeholder="Email"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    v-model="email"
                    class="w-full"
                  />
                  <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                  <vs-input
                    ref="password"
                    type="password"
                    data-vv-validate-on="blur"
                    v-validate="'required|min:8|max:15'"
                    name="password"
                    label-placeholder="Contraseña"
                    placeholder="Contraseña"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    v-model="password"
                    class="w-full mt-8" 
                  />
                  <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                  <div class="flex flex-wrap justify-end my-5">
                    <router-link to="forgot-password">¿Olvidó su contraseña?</router-link>
                  </div>
                  <div class="flex flex-wrap justify-between">
                    <vs-button  type="border" @click="register">
                      Regístrate
                    </vs-button>
                    <vs-button @click="login()" :disabled="!validateForm && loggedIn">
                      Ingresar
                    </vs-button>
                  </div>
                  
                  <div class="flex flex-wrap flex my-5 justify-between">
                      <vs-button  type="flat" to="/" icon-pack="feather" icon="icon-arrow-left" v-if="loggedIn">Volver al Dashboard</vs-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { authComputed } from '@/store/helpers.js'
import logo from '@/layouts/components/Logo.vue'
export default{
  name: 'login',
  components: {
    logo
  },
  data () {
    return {
      email: null,
      password: null
    }
  },
  computed: {
    ...authComputed,
    validateForm () {
      return (!this.errors.any() && this.email !== '' && this.password !== '')
    }
  },
  methods: {
    register () {
      this.$router.push({ name: 'register' }) 
    },
    login () {
      this.$vs.loading()
      this.$store.dispatch('login', {
        email: this.email,
        password: this.password
      })
        .then(() => {
          this.$vs.notify({
            title: 'Ingreso exitoso',
            text: '¡Has iniciado sesión!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            time: 6000
          })
          this.$store.dispatch('fetchUserData')
            .then(() => { 
              const userRoles = JSON.parse(localStorage.getItem('userRoles'))    
              if (userRoles && userRoles.some(item => item.id_role < 40)) {
                this.$acl.change('admin')
                this.$vs.loading.close()
                this.$router.push({ name: 'dashboard' }) 
                
              } else if (userRoles && userRoles.some(item => item.id_role > 50)) {
                this.$acl.change('client') //clientes de extranjeria
                this.$vs.loading.close()
                this.$router.push({ name: 'dashboard-clientes' }) 
              } else {
                this.$acl.change('public')
                this.$vs.loading.close()
                this.$router.push({ name: 'dashboard-clientes' })
              } 
            })
          
        })
        .catch(error => {
          this.$vs.loading.close()
          console.error(error)
          this.$vs.notify({
            title: 'Ingreso Fallido',
            text: `${error.response.data.error}`, //error me lo traigo del back
            iconPack: 'feather',
            icon: 'icon-x-circle',
            color: 'warning',
            time: 6000
          })
        })
    }
  } 
}
</script>

